export function openCalendly(eventType: string) {
  window.open(`https://calendly.com/deploai/${eventType}`, '_blank');
}
